import script from "./Antrag1Button.vue?vue&type=script&setup=true&lang=js"
export * from "./Antrag1Button.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__